<template>
  <div class="content">
    <div class="header">
      <el-button @click="setComponents('CustomerRentEditor')">返回</el-button>
    </div>
    <div class="body">
      <div class="table-wrap">
        <el-table
          v-loading="loading"
          v-if="pageData" :data="pageData.list"
          border
          style="width: 100%">
          <el-table-column
            prop="id"
            label="承租人编号" width="100">
            <template slot-scope="scope">
              <el-link type="primary" @click="setComponents('CustomerRentEditor',scope.row.id)">{{scope.row.id}}</el-link>
            </template>
          </el-table-column>
          <el-table-column
            prop="rent_customer_name"
            label="承租人姓名"
            width="150">
            <template slot-scope="scope">
              <el-link type="primary" @click="showEditor(scope.row.rent_customer_id)">{{scope.row.rent_customer_name}}</el-link>
            </template>
          </el-table-column>
          <el-table-column
            prop="customer_name"
            label="业主名称"
            width="150">
            <template slot-scope="scope">
              <el-link type="primary" @click="showEditor(scope.row.customer_id)">{{scope.row.customer_name}}</el-link>
            </template>
          </el-table-column>
          <el-table-column
            prop="contract_id"
            label="合同编号"
            width="100">
          </el-table-column>
          <el-table-column
            prop="begin_date"
            label="承租日期"
            width="150">
          </el-table-column>
          <el-table-column
            prop="cease_date"
            label="退租日期"
            width="150">
          </el-table-column>
          <el-table-column
            prop="security_remark"
            label="安全管理"
            width="150">
          </el-table-column>
          <el-table-column
            prop="op_user_name"
            label="操作人"
            width="100">
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-wrap">
        <el-pagination background layout="prev, pager, next" :total="pageData.total*1"
                       :page-size="pageData.pageSize*1" :current-page="pageData.page*1"
                       @current-change="pageChange"></el-pagination>
      </div>
    </div>
    <editor v-model="editor.visable" :classValue="editor.classValue" :id="editor.id" :is_edit="false" @callback="editorCallback" />
  </div>
</template>

<script>

import Editor from "../../../Customer/editor";

export default {
  name: "CustomerRentHistory",
  components:{Editor},
  inject:["mainObj","setComponentsId"],
  data(){
    return{
      where:{
        house_id:"",
        house_name:"",
        isCeased:[1,0],
        txtOwnerName:"",
        txtBeginBeginDate:"",
        txtBeginEndDate:"",
        txtRentCustomerName:"",
        txtCeasedBeginDate:"",
        txtCeasedEndDate:"",
        HouseNumber:"",
      },
      loading:false,
      pageData: {
        list: [],
        total: 0,
        pageSize: 15,
        page: 1,
      },
      editor:{
        classValue:1,
        id:0,
        visable:false
      },
    }
  },
  activated() {
    this.where.house_id=this.history_house_id;
    this.where.house_name=this.history_house_name;
    this.getList()
  },
  watch: {
    house_id(n,o){
      this.where.house_id=n;
    },
    house_name(n,o){
      this.where.house_name=n;
      this.pageChange(1)
    }
  },
  computed:{
    history_house_id(){
      return (this.mainObj||{}).history_house_id||''
    },
    history_house_name(){
      return (this.mainObj||{}).history_house_name||''
    },
  },
  methods:{
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    getList() {
      const that=this;
      let where={
        ...that.where,
        pageSize:that.pageData.pageSize,
        page:that.pageData.page,
      }
      ERP.postRequest({url:"admin/HouseRent/getList",data:where},ret=>{
        if(ret.code){
          that.pageData=ret.data;
        }else{
          this.$msgbox.alert(ret.msg||"查询失败")
        }
      })
    },
    showEditor(customer_id) {
      const that=this;
      that.getCustomerBase(customer_id,data=>{
        that.editor.classValue = data.class
        that.editor.id = customer_id
        that.editor.visable = true
      })
    },
    getCustomerBase(customer_id,callback){
      ERP.getRequest({
        url: "admin/Customer/getCustomerBase",
        data: {
          id: customer_id,
        }
      }, res => {
        if (res.code) {
          typeof callback ==="function"&&callback(res.data);
        }
      })
    },
    editorCallback(arg) {
      // this.getList()
      if(arg && arg[0]) this.editor.id = arg[0]
    },
    setComponents(componentsId,id=""){
      this.mainObj.rent_id=id;
      this.setComponentsId(componentsId)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/User/CustomerManagement/components/CustomerRentHistory.vue